import { defineChain } from "viem";

export const stable = defineChain({
  id: 988,
  name: "Stable",
  nativeCurrency: {
    decimals: 18,
    name: "GUSDT",
    symbol: "gUSDT",
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.stable.xyz"],
      webSocket: ["wss://rpc.stable.xyz"],
    },
  },
  blockExplorers: {
    default: { name: "Explorer", url: "stablescan.xyz" },
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 2423647,
    },
  },
});
